import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, {
  BASIC_BUTTON_TYPE_FILLED,
  BASIC_BUTTON_TYPE_FLAT,
  BASIC_BUTTON_TYPE_OUTLINED,
} from '@divvy-web/skylab.basicbutton'

import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { logInfo } from '@sputnik/utils/loggerUtils'

interface GoToDashboardButtonProps {
  componentName: string
  dataTestId?: string
  onClick?: () => void
  buttonType?: typeof BASIC_BUTTON_TYPE_FLAT | typeof BASIC_BUTTON_TYPE_OUTLINED | typeof BASIC_BUTTON_TYPE_FILLED
}

const GoToDashboardButton = ({
  componentName,
  dataTestId,
  onClick,
  buttonType = BASIC_BUTTON_TYPE_FILLED,
}: GoToDashboardButtonProps) => {
  const [makeTestId, getClassName] = useNameFormatter('GoToDashboardButton')
  const navigate = useNavigate()
  const { appId } = useParams()

  const handleGoToDashboardClick = () => {
    logInfo('creditAppExit', {
      attributes: {
        creditAppId: appId,
        destination: PATHNAME_CONSTS.DASHBOARD_PATH,
      },
      message: `Navigating to dashboard from ${componentName}`,
    })
    onClick?.()
    navigate(PATHNAME_CONSTS.DASHBOARD_PATH)
  }

  return (
    <BasicButton
      className={getClassName('')}
      dataTestId={makeTestId(dataTestId || '')}
      type={buttonType}
      onClick={handleGoToDashboardClick}
    >
      <FormattedMessage
        defaultMessage='Go to dashboard'
        id='sputnik.GoToDashboardButton__Oeu69m'
      />
    </BasicButton>
  )
}

export default GoToDashboardButton
